export interface CrewEntry {
  name: string;
  initials: string;
  isCoPlanner?: boolean;
}

export interface OnboardingData {
  // Step 1
  tripName: string;
  destination: string;
  occasion: string;
  startDate: string;
  endDate: string;
  // Step 2
  crew: CrewEntry[];
  // Step 3
  lodgingName: string;
  lodgingAddress: string;
  lodgingAccessCode: string;
  lodgingCheckInDate: string;
  lodgingCheckInTime: string;
  lodgingCheckOutDate: string;
  lodgingCheckOutTime: string;
  lodgingUrl: string;
}

export const initialOnboardingData: OnboardingData = {
  tripName: '',
  destination: '',
  occasion: '',
  startDate: '',
  endDate: '',
  crew: [],
  lodgingName: '',
  lodgingAddress: '',
  lodgingAccessCode: '',
  lodgingCheckInDate: '',
  lodgingCheckInTime: '',
  lodgingCheckOutDate: '',
  lodgingCheckOutTime: '',
  lodgingUrl: '',
};

export function getInitials(name: string): string {
  return name
    .split(' ')
    .filter(Boolean)
    .map((part) => part[0].toUpperCase())
    .slice(0, 2)
    .join('');
}
